import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import GroupShowStore from 'stores/GroupShowStore';
import DesktopStreaming from 'components/DesktopStreaming/DesktopStreaming';
import MobileShowTransition from 'components/MobileShowTransition/MobileShowTransition';


const GroupShowDesktop = (props) => {
  const { user, roomName, roomDataReady, isUserInRoster } = props;
  const { groupShowTransition, handleDisconnectFromGroupShowChat } = GroupShowStore;

  useEffect(
    () =>
      () => handleDisconnectFromGroupShowChat(roomName),
    [handleDisconnectFromGroupShowChat, roomName]
  );

  if (groupShowTransition) {
    return (
      <MobileShowTransition
        isDesktop={true}
        isGroupShow={true}
        isUserInRoster={isUserInRoster}
        roomDataReady={roomDataReady}
        roomName={roomName}
        user={user}
      />
    );
  }

  if (!groupShowTransition) {
    return <DesktopStreaming user={user} />;
  }

  return null;
};

GroupShowDesktop.propTypes = {
  isUserInRoster: PropTypes.bool,
  roomDataReady: PropTypes.bool,
  roomName: PropTypes.string,
  user: PropTypes.object,
};

GroupShowDesktop.defaultProps = {
  isUserInRoster: false,
  roomDataReady: false,
  roomName: undefined,
  user: undefined,
};

export default observer(GroupShowDesktop);
